import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const CallToAction = ({user}) => {
  return (
    <section className="relative w-full mx-auto text-center bg-gradient-to-l from-gray-600 to-gray-900 text-white py-8 px-6 shadow-lg overflow-hidden">
      <motion.h2 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl font-bold text-yellow-400 mb-4"
      >
        Boost Your Music Reach Today!
      </motion.h2>
      <motion.p 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="text-lg text-gray-200 mb-6"
      >
        Join thousands of artists growing their streams and fan base with our powerful promotion tools.
      </motion.p>
      <motion.button 
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="bg-yellow-400 text-gray-900 font-semibold py-3 px-6 rounded-full shadow-md hover:bg-yellow-300 transition duration-300"
      >
     {user?  <Link to='/user/upload-music'> Upload Music </Link>: <Link to='/sign-up'> Get Started Now </Link>}
      </motion.button>
    </section>
  );
};

export default CallToAction;